import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { Alert, ButtonIcon, Typography } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import Confirm from '../Confirm';

const { SLACK_NOTIFICATION_CHANNEL_NAME = 'video-platform-notifications' } =
  process.env;

export function RequestAlert({ sport, matchId }) {
  const api = useApi();
  const intl = useIntl();

  const [displayConfirmation, setDisplayConfirmation] = useState();
  const [localMessage, setLocalMessage] = useState();

  const { getIdTokenClaims } = useKitbagAuth();

  const requestAlert = async () => {
    try {
      const { email } = await getIdTokenClaims();
      const response = await api.post(
        `${API_ENDPOINTS.videoService}/alert?sport=${sport}&match_id=${matchId}&email=${email}`,
      );
      if (response.data) {
        setDisplayConfirmation(false);
        setLocalMessage('');
      } else {
        setLocalMessage(
          intl.formatMessage({
            defaultMessage: 'Failed to request alerts',
            id: 'bee31',
          }),
        );
      }
    } catch {
      setLocalMessage(
        intl.formatMessage({
          defaultMessage: 'Error requesting alerts',
          id: '1f390',
        }),
      );
    }
  };

  return (
    <>
      <ButtonIcon
        icon="Visibility"
        onClick={() => setDisplayConfirmation(true)}
        title={intl.formatMessage({
          defaultMessage: 'Request Alerts',
          id: '12f85',
        })}
        variant="secondary"
      />
      <Confirm
        id="video-combine"
        isOpen={displayConfirmation}
        onCancel={() => setDisplayConfirmation(false)}
        onConfirm={requestAlert}
      >
        {(api.errorMessage || localMessage) && (
          <Alert type="error">
            {localMessage ||
              intl.formatMessage({
                defaultMessage: 'Failed to save request for alerts',
                id: 'c3256',
              })}
          </Alert>
        )}
        <Typography variant="headingSmall">
          <FormattedMessage
            // eslint-disable-next-line max-len
            defaultMessage="Alerts will be sent for {sport} #{matchId} via slack channel #{channelName} when new videos are added?"
            id="88aea"
            values={{
              channelName: SLACK_NOTIFICATION_CHANNEL_NAME,
              matchId,
              sport,
            }}
          />
        </Typography>
      </Confirm>
    </>
  );
}

RequestAlert.propTypes = {
  matchId: PropTypes.string.isRequired,
  sport: PropTypes.string.isRequired,
};

export default { RequestAlert };
